module.exports = __webpack_public_path__ + "static/media/ic_search.d633c7da.svg";